import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `TipoInstalacion/imprimirTipoInstalacion`, method: 'POST', body: list, token: token})
}